import { useEffect, useState } from "react";
import { MatrizTransaccional } from "../../models/monitoreo/MatrizTransaccional";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Generico } from "../../components/Generico";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { TablaTransaccional } from "./TablaTransaccional";
import { useToken } from "../../components/useToken";

export const ListaTransaccion = ({ toast, permss, funcionalidades, generic }) => {
    const omodel = new MatrizTransaccional();
    const model = omodel.model;
    const defaultValues = generic.funDefault(model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const [registers, setRegisters] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams, inText, inCalendar } = InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });
    const monitoreoSrv = new MonitoreoService();
    const [dialogMatriz, setDialogMatriz] = useState(false);
    const [matriz, setMatriz] = useState(null);
    const [tablaTemporal, setTablaTemporal] = useState(false);
    const [dialogMonitoreo, setDialogMonitoreo] = useState(false);
    const { accionesTbl } = Generico();
    const { getRol } = useToken();
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-matriz-transaccional',
            message: '¿Está seguro de eliminar la matriz?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarMonitoreo()
        });
    }

    const eliminarMonitoreo = () => {
        monitoreoSrv.eliminar(matriz?.id, 'monitoreo/transaccional/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogMatriz(true);
    }

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        monitoreoSrv.listado('monitoreo/transaccional/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
        });
    }

    const onSubmit = (data) => {
        data.fecha_inicio = generic.dateToString(data.fecha_inicio);
        data.fecha_fin = generic.dateToString(data.fecha_fin);
        setGuardando(true);
        if (getValues('id') == null) {
            data.tipo_rango_fecha = 'TIP_RAN_FEC_MATRIZ_FECHAS';
            monitoreoSrv.nuevo(data, 'monitoreo/transaccional/generar-temporal').then(res => {
                setTablaTemporal(true);
                setMatriz(res.data);
                setDialogMatriz(false);
                setDialogMonitoreo(true);
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setGuardando(false);
            });
        }
        else {
            monitoreoSrv.editar(data, 'monitoreo/transaccional/editar').then(res => {
                setDialogMatriz(false);
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setGuardando(false);
            });
        }
    }

    const editar = () => {
        monitoreoSrv.consultar(matriz?.id, 'monitoreo/transaccional/consulta').then(res => {
            const _mat = res.data;
            _mat.fecha_inicio = generic.stringToDate(_mat.fecha_inicio);
            _mat.fecha_fin = generic.stringToDate(_mat.fecha_fin);
            reset(generic.renewValues(_mat, model));
            setDialogMatriz(true);
        });
    }

    const itemsMenu = () => {
        const items = [];
        // Estado BORRADOR
        if (matriz?.nemonico === 'BORRADOR') {
            if (permss?.actualizar)
                items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
            if (permss?.actualizar)
                items.push({ label: 'Ver monitoreo', icon: 'pi pi-bars', command: () => { setTablaTemporal(false); setDialogMonitoreo(true) } });
            if (permss?.eliminar)
                items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        // Estado ENVIADO
        if (matriz?.nemonico === 'ENVIADO') {
        }
        // Estado FINALIZADO
        if (matriz?.nemonico === 'FINALIZADO') {
            if (permss?.actualizar)
                items.push({ label: 'Ver monitoreo', icon: 'pi pi-bars', command: () => { setTablaTemporal(false); setDialogMonitoreo(true) } });
        }
        return [{ label: 'Opciones', items }];
    }

    const handleCloseTabla = (seGuardo = false) => {
        setDialogMonitoreo(false);
        setMatriz(null);
        if (seGuardo) {
            loadLazyData();
        }
    };

    return (
        <>
            <ConfirmDialog group="eliminar-matriz-transaccional" className="dialog-personalizado" />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {!dialogMonitoreo && <><Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, '', permss)}></Toolbar>
                    {table({ action01: accionesTbl, reg: setMatriz, items: itemsMenu() })}</>}
                {dialogMonitoreo && <TablaTransaccional tablaTemporal={tablaTemporal} matriz={matriz} permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generic} handleCloseTabla={handleCloseTabla} />}
            </Card>

            <Dialog visible={dialogMatriz} header={getValues('id') == null ? "Nueva matriz de monitoreo" : "Editar matriz de monitoreo"} modal className="p-fluid modal-ssize"
                onHide={() => { setDialogMatriz(false); }}
                style={{ maxWidth: '500px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {getValues('id') !== null && (
                            <>
                                {inText('nombre', { icon: 'pi pi-pencil' }, 12)}
                                {inText('codigo', { icon: 'pi pi-align-left' }, 12)}
                                {inText('observacion', { icon: 'pi pi-qrcode' }, 12)}
                            </>
                        )}
                        {inCalendar('fecha_inicio', { obl: 'no', disabled: getValues('id') !== null }, 6)}
                        {inCalendar('fecha_fin', { obl: 'no', disabled: getValues('id') !== null }, 6)}
                    </div>
                    {generic.buttonsForms(setDialogMatriz, guardando)}
                </form>
            </Dialog>
        </>
    )
}
